import React from 'react'
import '../styles/card.css'
import { Link } from 'react-router-dom'

export default function ProductsCard() {
  return (
    <section className='ProductsCard'>
      <div className="container">
        <div className="row">
          <div className="col-md-4 mb-3">
            <div className="card kard card1">
              <div className="card-content">
                <h2 className="card-title">Мягкая мебель</h2>
                <p className="card-body">
                </p>
                <Link className='button' to='/products'>Посмотреть </Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-3">
            <div className="card kard card2">
              <div className="card-content">
                <h2 className="card-title">Столы стулья</h2>
                <p className="card-body">
                </p>
                <Link className='button' to='/products'>Посмотреть </Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-3">
            <div className="card kard card3">
              <div className="card-content">
                <h2 className="card-title">Шкаф</h2>
                <p className="card-body">
                </p>
                <Link className='button' to='/products'>Посмотреть </Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-3">
            <div className="card kard card4">
              <div className="card-content">
                <h2 className="card-title">Кровать</h2>
                <p className="card-body">
                </p>
                <Link className='button' to='/products'>Посмотреть </Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-3">
            <div className="card kard card5">
              <div className="card-content">
                <h2 className="card-title">Спальныйгарнитур</h2>
                <p className="card-body">
                </p>
                <Link className='button' to='/products'>Посмотреть </Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-3">
            <div className="card kard card6">
              <div className="card-content">
                <h2 className="card-title">Трюмо камоды</h2>
                <p className="card-body">
                </p>
                <Link className='button' to='/products'>Посмотреть </Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-3">
            <div className="card kard card7">
              <div className="card-content">
                <h2 className="card-title">Прихожки</h2>
                <p className="card-body">
                </p>
                <Link className='button' to='/products'>Посмотреть </Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-3">
            <div className="card kard card8">
              <div className="card-content">
                <h2 className="card-title">Прочая мебель</h2>
                <p className="card-body">
                </p>
                <Link className='button' to='/products'>Посмотреть </Link>
              </div>
            </div>
          </div>

          

        </div>
      </div>
    </section>
  )
}
